export const getAcademyIframeSource = () => {
  const fallback = 'https://cms.academy.klaviyo.com';

  if (process.env.GENERATOR === 'astro') {
    return (
      // @ts-ignore: ImportMeta is not defined in a cross-site way
      import.meta.env.PUBLIC_IFRAME_SOURCE
      || process.env.PUBLIC_IFRAME_SOURCE
      || fallback
    );
  }

  return (
    process.env.GATSBY_IFRAME_SOURCE
    // @ts-ignore: ImportMeta is not defined in a cross-site way
    || import.meta.env.GATSBY_IFRAME_SOURCE
    || fallback
  );
};
